import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache, doc, getDocFromServer } from 'firebase/firestore';
import firebaseConfig from '../../firebase-applet-config.json';

export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Firestore con persistencia offline (IndexedDB) para que todos los navegadores
// vean los mismos datos: la caché offline se mantiene entre sesiones.
// Se usa el database ID nombrado del proyecto para conectar a la base correcta.
export const db = initializeFirestore(
  app,
  {
    localCache: persistentLocalCache({ cacheSizeBytes: 10485760 }) // 10MB
  },
  firebaseConfig.firestoreDatabaseId
);

export async function testFirestoreConnection(): Promise<{ success: boolean; error?: string; config: { projectId: string; databaseId: string } }> {
  try {
    await getDocFromServer(doc(db, 'insumedic_companies_v3', 'company-insumedic'));
    return {
      success: true,
      config: {
        projectId: firebaseConfig.projectId,
        databaseId: firebaseConfig.firestoreDatabaseId
      }
    };
  } catch (error: any) {
    if (error instanceof Error && error.message.includes('the client is offline')) {
      console.warn('Firestore notice: Client is operating in offline/cached mode.', error.message);
    } else {
      console.warn('Firestore live connection test result:', error?.message || error);
    }
    return {
      success: !error?.message?.includes('the client is offline'),
      error: error?.message,
      config: {
        projectId: firebaseConfig.projectId,
        databaseId: firebaseConfig.firestoreDatabaseId
      }
    };
  }
}

// Initial diagnostic probe
testFirestoreConnection().catch(() => {});
